/**
 * @packageDocumentation
 * @module f1/string
 */

import to_regexp from '../to/to_regexp';

export interface Match {
  /**
   * Find one occurrence of a regular expression in a string as an array of matches
   *
   * @public
   * @function f1.match
   * @param regExp the regular expression to match again
   * @param s the string to search
   * @example
   *
   * ```ts
   * f1.match(/[a|b]/g, 'ab') == ['a', index: 0, input: 'a'];
   * ```
   */
  (regExp: RegExp | string, s: string): RegExpMatchArray;
  (regExp: RegExp | string): (s: string) => RegExpMatchArray;
}

/**
 * @see Match
 */
export default (regExp: RegExp | string, s: string) => {
  return s.match(to_regexp(regExp)) || [];
};
